import { Divider, Tooltip } from '@mui/material';
import { format } from 'date-fns';
import {
  DatagridConfigurable,
  DateField,
  FunctionField,
  NumberField,
  TextField,
  useTranslate,
} from 'react-admin';

import { BulkActions } from '@/view/employees/EmployeesList/components/BulkActions';
import { Murmurhash3 } from '@/utils';
import { COHORTS_COLORS } from '@/constants/cohorts';

interface ITabbedDatagridProps {
  handleOpenSuspendEmployeesModal: () => void;
}

function TabbedDatagrid({ handleOpenSuspendEmployeesModal }: ITabbedDatagridProps): JSX.Element {
  const t = useTranslate();

  return (
    <>
      <Divider />
      <DatagridConfigurable
        rowClick={false}
        bulkActionButtons={
          <BulkActions handleOpenSuspendEmployeesModal={handleOpenSuspendEmployeesModal} />
        }
      >
        <TextField source="first_name" label="resources.employees.first_name" sortable={false} />
        <TextField source="last_name" label="resources.employees.last_name" sortable={false} />
        <TextField source="itn" label="resources.employees.itn" sortable={false} />
        <FunctionField
          sortable={false}
          label="resources.employees.status"
          render={(record: any) => {
            if (record.status === 'Призупинений') {
              const dates: Date[] = record.termination_dates?.map((item: string) => new Date(item));
              let title = t('resources.employees.termination_dates.until_recovered');

              if (dates?.length) {
                dates.sort((a, b) => b.getTime() - a.getTime());

                const postfix = t('resources.employees.termination_dates.selected_dates');
                title = `${format(dates[0], 'dd.MM')} ${postfix}`;
              }

              return (
                <Tooltip title={title} arrow>
                  {record.status}
                </Tooltip>
              );
            }

            return record.status;
          }}
        />
        <TextField
          source="phone_number"
          label="resources.employees.phone_number"
          sortable={false}
        />
        <FunctionField
          sortable={false}
          label="resources.employees.cohort_name"
          render={(record: any) => {
            const cohortName = record.cohort?.name || t('resources.employees.default_cohort_name');

            const hash = Murmurhash3.murmur3(cohortName, 10);
            const colorIndex = hash % COHORTS_COLORS.length;
            const color = COHORTS_COLORS[colorIndex];

            return <span style={{ color }}>{cohortName}</span>;
          }}
        />
        <DateField source="last_update" label="resources.employees.last_update" showTime />
        <NumberField
          sortable={false}
          source="available_salary"
          label="resources.employees.available_salary"
          emptyText="-"
          options={{ style: 'currency', currency: 'UAH' }}
        />
        <NumberField
          sortable={false}
          source="total_withdrawal_amount"
          label="resources.employees.total_withdrawal_amount"
          emptyText="-"
          options={{ style: 'currency', currency: 'UAH' }}
        />
        <FunctionField
          sortable={false}
          label="resources.employees.total_transactions"
          render={(record: any) =>
            record.max_withdrawal_count >= 0
              ? `${record.total_transactions} / ${record.max_withdrawal_count}`
              : '-'
          }
        />
        <NumberField
          sortable={false}
          source="average_salary"
          label="resources.employees.average_salary"
          options={{ style: 'currency', currency: 'UAH' }}
        />
        {/*<EditButton />*/}
      </DatagridConfigurable>
    </>
  );
}

export default TabbedDatagrid;
